import { Language } from "@omni/schemas/config/language.schema";

import { Dropdown } from "@/components/General/Dropdown/dropdown.component";
import { getLabel } from "@/components/General/LanguageSelector/partials/label.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { setLanguageCookie } from "@/services/cookie.service";

import { useLanguageSelectorPath } from "../../languageSelector.helper";

type DropdownLanguageItemProps = {
    language: Language;
    isDisabled: boolean;
    variant?: string;
};

export const DropdownLanguageItem = ({
    language,
    isDisabled,
    variant
}: DropdownLanguageItemProps) => {
    const { t } = useGranite();

    const newPath = useLanguageSelectorPath(language.url);

    const handleOnClick = () => {
        setLanguageCookie(language["language-code"]);
    };

    return (
        <Dropdown.Item
            disabled={isDisabled}
            tag={"a"}
            href={newPath}
            onClick={handleOnClick}
            label={getLabel({ language: language, variant: variant, t: t })}
        />
    );
};
